import { useState } from "react";
import styles from "./index.module.scss";
import kesaiSrc from "../assets/robot.jpg";

const menuItems = [
  {
    key: "intro",
    label: "大赛介绍",
  },
  {
    key: "setup",
    label: "赛道设置",
  },
  {
    key: "participants",
    label: "参赛对象",
  },
  {
    key: "guests",
    label: "竞赛嘉宾",
  },
  {
    key: "schedule",
    label: "赛程安排",
  },
  {
    key: "prizes",
    label: "奖项设置",
  },
  {
    key: "contact",
    label: "联系我们",
  },
];

export const WebRobot2024 = () => {
  const [active, setActive] = useState("intro");

  return (
    <div className={styles.page}>
      <div className={styles["logo"]}></div>
      <div className={styles["menu"]}>
        {menuItems.map((it) => (
          <div
            id={`item-${it.key}`}
            key={it.key}
            className={`${styles["item"]} ${
              active === it.key ? styles["active"] : ""
            } ${it.key === "contact" ? styles["contact"] : ""}`}
            onClick={() => {
              setActive(it.key);
              const anchorDom = window.document.querySelector(`#anchor-${it.key}`)
              anchorDom.scrollIntoView({
                behavior: "smooth"
              })
            }}
          >
            {it.label}
          </div>
        ))}
      </div>
      <div className={styles["top-bg"]}></div>
      <div className={styles["circle"]}></div>
      <div className={styles["circle-shadow"]}></div>
      <div className={styles["line"]}></div>


      <div className={styles["title-intro"]} id="anchor-intro"></div>
      <div className={`${styles["intro-dot"]} ${active === 'intro' ? styles["selected"] : ''}`}></div>
      <div className={styles["text-intro"]}></div>

      <div className={styles["title-setup"]} id="anchor-setup"></div>
      <div className={`${styles["setup-dot"]} ${active === 'setup' ? styles["selected"] : ''}`}></div>
      <div className={styles["quiz1"]}></div>
      <div className={styles["quiz2"]}></div>
      <div className={styles["quiz3"]}></div>
      <div className={styles["quiz4"]}></div>
      <div className={styles["quiz5"]}></div>

      <div className={styles["btn-entry1"]}>
        <div className={styles["kesai-scan"]}>
          <img src={kesaiSrc} alt="可赛小程序码" />
        </div>
      </div>


      <div
        className={styles["title-participants"]}
        id="anchor-participants"
      ></div>
      <div className={`${styles["participants-dot"]} ${active === 'participants' ? styles["selected"] : ''}`}></div>
      <div className={styles["text-participants"]}></div>
      <div className={styles["icon-participants"]}></div>
      <div className={styles["border-participants"]}></div>

      <div className={styles["title-guests"]} id="anchor-guests"></div>
      <div className={`${styles["guests-dot"]} ${active === 'guests' ? styles["selected"] : ''}`}></div>
      <div className={styles["guests__wrapper"]}>
        <div className={styles['guests-1']}></div>
        <div className={styles['guests-2']}></div>
        <div className={styles['guests-3']}></div>
        <div className={styles['guests-4']}></div>
        <div className={styles['guests-5']}></div>
        <div className={styles['guests-6']}></div>
      </div>

      <div className={styles["title-schedule"]} id="anchor-schedule"></div>
      <div className={`${styles["schedule-dot"]} ${active === 'schedule' ? styles["selected"] : ''}`}></div>
      <div className={styles["contest-timeline"]}></div>

      <div className={styles["title-prizes"]} id="anchor-prizes"></div>
      <div className={`${styles["prizes-dot"]} ${active === 'prizes' ? styles["selected"] : ''}`}></div>
      <div className={styles["prizes-1"]}></div>
      <div className={styles["prizes-2"]}></div>
      <div className={styles["prizes-3"]}></div>
      <div className={styles["prizes-4"]}></div>
      <div className={styles["prizes-desc"]}></div>

      <div className={styles["footer"]}>
        <div className={styles["title-contact"]} id="anchor-contact"></div>
        <div className={styles["text-contact"]}></div>
      </div>
    </div>
  );
};
